/** The fixed header: menu links, the language button and the menu labels. */

export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Why MeetNPlan', href: '/#why' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'User guide', href: '/guide' },
  { label: "What's new", href: '/updates' },
  { label: 'Contact us', href: '/contact' },
]

/** The header's round language button: it offers the *other* language. */
export const LANGUAGE = { label: 'ع', title: 'التبديل إلى العربية', lang: 'ar' }

/** Labels for the menu button and the full-screen menu's close button. */
export const MENU = { open: 'Menu', close: 'Close menu' }
